export default {
  Draft: "Draft",
  SubmittedToPrincipalAdmin: "SubmittedToPrincipalAdmin",
  SentToFunder: "SentToFunder",
  DealRejected: "DealRejected",
  Live: "Live"
};
